<template>
  <div class="index atb-flex atb-flex-column">
    <div class="top atb-flex ">
      <route-btn @go="goPage" v-for="(item, index) in routeList" :key="item.name" :item="item" :colorType="((index + 1) % 5).toString()"></route-btn>
      <route-btn :item="{ functionName: '添加', icon: 'icon-add' }" colorType="add" className="atb-icon-color" @click.native="addRoute"></route-btn>
    </div>
    <div class="bot atb-flex">
      <div class="msg atb-content-bg atb-flex atb-flex-column">
        <sub-title title="消息提醒"></sub-title>
        <el-scrollbar :vertical="true">
          <ul class="msg-list ">
            <template v-for="(item, index) in noticeList">
              <el-tooltip class="item" :key="item.id" effect="dark" :content="item.msgContent" placement="top">
                <li class="msg-ellipsis" @click="goDetail(item)" @dblclick="openPage(item)">
                  <div class="msg-content-1">
                    <div v-if="index <= 2" class="s-urgent">
                      <i class="icon-urgent"></i>
                    </div>
                    <div v-else class="a-urgent">
                      <span :class="index > 2 && index <= 5 ? style_3_5 : style_more_5"></span>
                    </div>
                    <!-- <div class="msg-content"> -->
                    <div class="msg-content-text">{{ item.msgContent }}</div>
                  </div>
                  <div class="msg-content-2">
                    <i class="icon-avatar-93"></i>{{ item.sendName }} <i class="icon-time-94"></i
                    >{{ item.creationTime ? XEUtils.toDateString(new Date(item.creationTime), 'yyyy-MM-dd') : '' }}
                  </div>
                  <!-- </div> -->
                </li>
              </el-tooltip>
            </template>
          </ul>
        </el-scrollbar>
      </div>
      <div class="kpi atb-flex atb-flex-column atb-content-bg">
        <sub-title title="未完成工作" class="notice-title atb-flex atb-flex-items-center atb-flex-justify-between">
          <template v-slot:right>
            <div class="handle atb-flex atb-flex-items-center">
              <el-radio-group v-model="searchParam.Type" @change="changeModel" class="atb-flex atb-flex-items-center">
                <el-radio label="">全部</el-radio>
                <el-radio label="yearwork">年工作</el-radio>
                <el-radio label="monthwork">月工作</el-radio>
                <el-radio label="weekwork">周工作</el-radio>
              </el-radio-group>
              <div class="refresh atb-flex atb-flex-items-center" @click="refreshList"><i class="icon-refresh"></i>刷新</div>
            </div>
          </template>
        </sub-title>
        <div class="table-content">
          <vxe-table
            stripe
            auto-resize
            highlight-hover-row
            class="atb-table"
            border="inner"
            ref="home"
            height="100%"
            :data="tableData"
            @cell-click="expandRow"
            @sort-change="sortChange"
            :sort-config="{ trigger: 'cell', sortMethod: customSortMethod, remote: true }"
            :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
          >
            <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
            <vxe-table-column field="title" min-width="120px" title="标题">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.title }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workClassify" title="工作分类" min-width="120px" sortable>
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ workClassifyName(row) }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workItemContent" min-width="100px" title="工作项目">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemContent }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="currentTarget" min-width="100px" title="当前目标">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.currentTarget }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="currentFinishDate" min-width="150px" title="当前目标完成时间">
              <template #default="{row}">
                <span>{{ row.currentFinishDate ? XEUtils.toDateString(new Date(row.currentFinishDate), 'yyyy-MM-dd') : '' }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="wholeTarget" min-width="150px" title="总目标">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="finishDate" min-width="150px" title="总目标完成时间" sortable>
              <template #default="{row}">
                <span>{{ row.finishDate ? XEUtils.toDateString(new Date(row.finishDate), 'yyyy-MM-dd') : '' }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="completeStatus" min-width="120" title="完成情况" sortable>
              <template #default="{ row }">
                <div v-if="row.type == 'yearwork'">
                  <el-tag v-if="row.status !== 60" type="ongoing" effect="dark">
                    未完成
                  </el-tag>
                  <el-tag v-else type="complete" effect="dark">
                    已完成
                  </el-tag>
                </div>
                <div v-else>
                  <!-- <el-tag v-if="row.completeStatus === 0" type="plan" effect="dark">
                    计划
                  </el-tag> -->
                  <el-tag v-if="row.completeStatus === 10" type="ongoing" effect="dark">
                    未完成
                  </el-tag>
                  <el-tag v-if="row.completeStatus === 20 && row.type == 'weekwork'" type="complete" effect="dark">
                    周目标已完成
                  </el-tag>
                  <el-tag v-if="row.completeStatus === 20 && row.type == 'monthwork'" type="complete" effect="dark">
                    月目标已完成
                  </el-tag>
                  <el-tag v-if="row.completeStatus === 25" type="complete" effect="dark">
                    总目标完成
                  </el-tag>
                  <el-tag v-if="row.completeStatus === 30" type="delay" effect="dark">
                    延迟
                  </el-tag>
                  <el-tag v-if="row.completeStatus === 40" type="transfer" effect="dark">
                    转移
                  </el-tag>
                  <el-tag v-if="row.completeStatus === 50" type="close" effect="dark">
                    关闭
                  </el-tag>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="age" title="操作" min-width="80px" class-name="operation" fixed="right">
              <template #default="scope">
                <div>
                  <el-tooltip
                    v-if="
                      scope.row.type == 'yearwork' &&
                        (scope.row.status === 20 || scope.row.status === 40 || scope.row.status === 50 || scope.row.status === 70) &&
                        scope.row.currentTarget
                    "
                    class="item"
                    effect="dark"
                    content="提交"
                    placement="bottom"
                  >
                    <i class="icon-send" @click.stop="submitYearSummary(scope.row)"></i>
                  </el-tooltip>
                  <el-tooltip
                    v-else-if="(scope.row.status === 20 || scope.row.status === 50) && scope.row.currentTarget && scope.row.currentFinishDate"
                    class="item"
                    effect="dark"
                    content="提交"
                    placement="bottom"
                  >
                    <i class="icon-send" @click.stop="submitMWSummary(scope.row)"></i>
                  </el-tooltip>
                  <el-tooltip v-if="disableEdit(scope.row)" class="item" effect="dark" content="修订" placement="bottom">
                    <i class="icon-revise" @click.stop="changeTarget(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                </div>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="page-con">
          <vxe-pager
            background
            :current-page.sync="page.PageIndex"
            :page-size.sync="page.PageSize"
            :total="total"
            height="100%"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
    <el-dialog title="全部应用" :visible.sync="dialogVisible" width="824px" custom-class="route-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <div class="common">
          <sub-title title="我的常用功能"></sub-title>
          <div class="result atb-bg-color-table-header atb-flex">
            <route-btn
              v-for="(item, index) in routeList"
              :key="item.name"
              :item="item"
              :colorType="((index + 1) % 5).toString()"
              operation="remove"
              @remove="remove"
            ></route-btn>
          </div>
        </div>
        <div class="all">
          <sub-title title="全部应用"></sub-title>
          <div class="result atb-flex">
            <route-btn
              v-for="(item, index) in allRouteList"
              :key="item.functionName"
              :item="item"
              :colorType="((index + 1) % 5).toString()"
              operation="plus"
              @plus="plus"
            ></route-btn>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="cancel" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="showNoticeDetail" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <li class="atb-flex">
          <span class="label">发件人</span>
          <span class="res name">{{ this.noticeDetail.sendName }}</span>
        </li>
        <li class="atb-flex">
          <span class="label">时间</span>
          <span class="res">{{
            this.noticeDetail.creationTime ? XEUtils.toDateString(new Date(this.noticeDetail.creationTime), 'yyyy-MM-dd') : ''
          }}</span>
        </li>
        <li class="atb-flex">
          <span class="label">消息类型</span>
          <span class="res">{{ this.msgTypeList.find(t=>t.value===this.noticeDetail.msgObjectType)? this.msgTypeList.find(t=>t.value===this.noticeDetail.msgObjectType).label: '' }}</span>
        </li>
        <li class="atb-flex">
          <span class="label">消息主题</span>
          <span class="res">{{ this.noticeDetail.msgObjectTitle }}</span>
        </li>
        <li class="atb-flex">
          <span class="label">消息内容</span>
          <span class="res notice-res">{{ this.noticeDetail.msgContent }}</span>
        </li>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="atb-dialog-confirm" type="primary" @click="showNoticeDetail = false">确认</el-button> -->
        <el-button class="atb-dialog-cancel" type="cancel" @click="showNoticeDetail = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修订" v-if="showChange" :visible.sync="showChange" width="600px" custom-class="changeDialog" @close="closeCreate" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <el-form ref="planForm" :model="form" label-width="95px" label-position="right" :rules="planRules">
          <el-form-item label="工作项分类" prop="workClassify">
            <el-select :disabled="ableClassify || form.source == 4" clearable v-model="form.workClassify" placeholder="工作项分类">
              <el-option v-for="item in workClassifyList" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类别" prop="workItemCategory">
            <el-autocomplete :disabled="form.source == 4" v-model="form.workItemCategory" :fetch-suggestions="queryCategory" placeholder="类别"></el-autocomplete>
          </el-form-item>
          <el-form-item label="工作项目" prop="workItemContent">
            <el-input :disabled="form.source == 4" rows="3" type="textarea" v-model="form.workItemContent" placeholder="工作项目"></el-input>
          </el-form-item>
          <el-form-item label="责任人" prop="resWkName">
            <el-input v-model="form.resWkName" disabled placeholder="责任人"></el-input>
          </el-form-item>
          <el-form-item label="总目标" prop="wholeTarget">
            <el-input :disabled="form.source == 4" rows="3" type="textarea" v-model="form.wholeTarget" placeholder="总目标"></el-input>
          </el-form-item>
          <el-form-item label="总目标完成时间" prop="finishDate">
            <el-date-picker :disabled="form.source == 4" v-model="form.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="当前目标" prop="currentTarget">
            <el-input rows="3" type="textarea" v-model="form.currentTarget" placeholder="当前目标"></el-input>
          </el-form-item>
          <el-form-item label="完成情况" v-if="form.type !== 'yearwork'" prop="completeStatus">
            <el-select clearable v-model="form.completeStatus" placeholder="完成情况">
              <el-option :disabled="item.itemValue == 40" v-for="item in completeList" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="完成情况" v-if="form.type !== 'yearwork' && form.type == 'weekwork'" prop="completeStatus">
            <el-select clearable v-model="form.completeStatus" placeholder="完成情况">
              <el-option :disabled="item.itemValue == 40" v-for="item in completeList" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item v-if="form.type !== 'yearwork'" label="当前目标完成时间" prop="currentFinishDate">
            <el-date-picker v-model="form.currentFinishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="权重" prop="weight">
            <el-autocomplete @change="regWeight(form)" v-model.trim="form.weight" :fetch-suggestions="weightSearch" clearable></el-autocomplete>
          </el-form-item>
          <el-form-item label="修订原因">
            <el-input rows="3" type="textarea" v-model="form.modifyReason" placeholder="修订原因"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirm">保存并发布</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showChange = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交总结" :visible.sync="showYearSummary" width="750px" custom-class="changeDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form :model="summaryForm" ref="yearSummaryForm" :rules="yearSummaryFormRules" label-width="80px" label-position="right">
          <el-form-item v-if="summaryForm.status === 20 || summaryForm.status === 50" label="半年总结" prop="firstHalfSummary">
            <el-input type="textarea" v-model="summaryForm.firstHalfSummary" :rows="5" placeholder="半年总结" clearable></el-input>
          </el-form-item>
          <el-form-item v-if="summaryForm.status === 40 || summaryForm.status === 70" label="全年总结" prop="fullSummary">
            <el-input type="textarea" v-model="summaryForm.fullSummary" :rows="5" placeholder="全年总结" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">提交</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showYearSummary = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交总结" :visible.sync="showMWSummary" width="750px" custom-class="changeDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form ref="summaryForm" :model="summaryForm" label-width="80px" label-position="right" :rules="summaryRules">
          <el-form-item label="完成情况" prop="completeStatus">
            <el-select clearable v-model="summaryForm.completeStatus" placeholder="完成情况">
              <el-option  v-for="item in completeList" :disabled="item.itemValue == 40" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总结" prop="reason">
            <el-input type="textarea" v-model="summaryForm.reason" :rows="5" placeholder="总结" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">提交</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showMWSummary = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="modifyApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :extend="dialogContent.extend"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="taskApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :msgId="dialogContent.msgId"
          @submitSuccess="getList()"
          :noticeType="dialogContent.noticeType"
          :msgObjectType="dialogContent.msgObjectType"
          :msgObjectChildId="dialogContent.msgObjectChildId"
          :sendName="dialogContent.sendName"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="yearApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :msgId="dialogContent.msgId"
          @submitSuccess="getList()"
          :noticeType="dialogContent.noticeType"
          :msgObjectChildId="dialogContent.msgObjectChildId"
          :sendName="dialogContent.sendName"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="transfer" :title="transferContent.title" width="900px" showClose>
      <template slot="content">
        <component
          v-bind:is="transferContent.componentName"
          :role="transferContent.role"
          :msg="transferContent.msg"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <el-dialog title="提示" :visible.sync="showTip" width="350px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <p>根据您当前电脑显示设置，自动调整到最佳体验。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="yes">是</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showTip = false">否</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="weekApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :msgObjectId='dialogContent.msgObjectId' :role="dialogContent.role" 
        :msgObjectChildId="dialogContent.msgObjectChildId" :noticeType="dialogContent.noticeType" :msgObjectType="dialogContent.msgObjectType" :sendName="dialogContent.sendName" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';
import _ from 'lodash';

export default {
  components: {
    modifyApprove: () => import('../notice/modifyApprove.vue'),
    taskApprove: () => import('../notice/taskApprove.vue'),
    yearApprove: () => import('../notice/yearApprove.vue'),
    transfer: () => import('../notice/transfer.vue'),
    weekApprove: () => import('../notice/weekApprove.vue'),
  },
  data() {
    return {
      XEUtils: XEUtils,
      routeList: [],
      allRouteList: [],
      dialogVisible: false,
      showNoticeDetail: false,
      showChange: false,
      tableData: [],
      searchParam: {
        Type: '',
        OrderByFinishDate: '',
        OrderByCompleteStatus: 0,
        GetUnfinished: 1,
        OrderByWorkClassify: '',
      },
      page: {
        PageSize: 10,
        PageIndex: 1,
      },
      total: 0,
      completeList: [],
      weekCompleteList: [],
      monthCompleteList: [],
      yearStatusList: [{ label: '已完成', value: 60 }],
      form: {},
      rowClone: {},
      approveReason: '',
      noticeList: [],
      noticeDetail: {},
      expandRowFlag: false,
      workClassifyList: [],
      summaryForm: {},
      showYearSummary: false,
      showMWSummary: false,
      yearWorkClassify: [],
      monthWorkClassify: [],
      weekWorkClassify: [],
      dialogContent: {},
      transferContent: {},
      style_3_5: 'style_3_5',
      style_more_5: 'style_more_5',
      win: window,
      showTip: false,
      showTipOnlyOnce: false,
      time: '',
      planRules: {
        workClassify: [{ required: true, message: '工作项分类必填', trigger: 'change' }],
        workItemContent: [
          { required: true, message: '工作项目必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' },
        ],
        wholeTarget: [
          { required: true, message: '总目标必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' },
        ],
        finishDate: [
          { required: true, message: '总目标完成时间必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' },
        ],
        currentTarget: [
          { required: true, message: '当前目标必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' },
        ],
        completeStatus: [{ required: true, message: '完成情况必填', trigger: 'change' }],
        currentFinishDate: [{ required: true, message: '当前目标完成时间必填', trigger: 'change' }],
        weight: [{ required: true, message: '权重必填', trigger: 'change' }],
      },
      summaryRules:{
         completeStatus: [
           { required: true, message: '完成情况必填', trigger: 'change' }
        ],
        reason: [
          { required: true, message: '总结必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' },
        ],
      },
      yearSummaryFormRules:{
         firstHalfSummary: [
          { required: true, message: '半年总结必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
         fullSummary: [
          { required: true, message: '全年总结必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
      },
      msgTypeList: [],
      ableClassify: false
    };
  },
  created() {
    if (this.win.devicePixelRatio > 1 && !sessionStorage.getItem('showTipOnlyOnce')) {
      this.showTip = true;
      sessionStorage.setItem('showTipOnlyOnce', true);
    }else{
      sessionStorage.getItem('zoom')&&(this.win.document.body.style.zoom = sessionStorage.getItem('zoom'));
    }
    this.getRouteList();
    this.getList();
    this.getNoticeList();
    this.getYearWorkClassify();
    this.getMonthWorkClassify();
    this.getWeekWorkClassify();
    this.getWeekWorkItemProcessStatus();
    this.getMonthWorkItemProcessStatus();
    this.getCategory();
    this.getMsgType();
  },
  mounted() {
    const menusStr = sessionStorage.getItem('menus') || '[]';
    this.allRouteList = this.allRouteList.filter(item => menusStr.includes(`"${item.path}"`))
    // 过滤详情页，不显示在我的应用里
    this.allRouteList = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
      .filter(
        (val) =>
          val.name !== 'OEC.PersonalConsole.WeekWork.Detail' &&
          val.name !== 'OEC.PersonalConsole.TbYearPlan.Detail' &&
          val.name !== 'OEC.PersonalConsole.MonthWork.Detail' &&
          val.name !== 'OEC.PersonalConsole.DayWork.Detail' &&
          val.name !== 'OEC.ManageConsole.ExecuteForm.Detail' &&
          val.name !== 'OEC.ManageConsole.EditPlan.Day' &&
          val.name !== 'OEC.ManageConsole.EditPlan.Year' &&
          val.name !== 'OEC.ManageConsole.EditPlan.Month' &&
          val.name !== 'OEC.ManageConsole.EditPlan.Week' &&
          val.name !== 'OEC.PersonalConsole.Workscore.Detail' &&
          val.name !== 'OEC.PersonalConsole.Workscore.YearDetail' &&
          val.name !== 'OEC.Period.Manage.WorkScoreList' &&
          val.name !== 'OEC.Period.Manage.WorkScore' &&
          val.name !== 'OEC.Period.Manage.YearWorkScore' &&
          val.name !== 'OEC.Period.ImportantSortSearch.Detail' &&
          val.name !== 'OEC.Response.Personal.Detail' &&
          val.name !== 'OEC.Response.History.Detail' &&
          val.name !== 'OEC.Response.Manage.Detail' &&
          val.name !== 'OEC.ManageConsole.EditPlan.YearNext' &&
          val.name !== 'OEC.PersonalConsole.TbYearPlan.DetailNext' &&
          val.name !== 'OEC.PersonalConsole.Workscore.YearDetailNext' &&
          val.name !== 'OEC.Period.Manage.YearWorkScoreNext'
      )
      .map((val) => {
        if (val.path == '/home/index') {
          val.meta.icon = 'icon-shouye';
        }
        return {
          functionUrl: val.path,
          functionName: val.meta.title,
          icon: val.meta.icon,
        };
      });
  },
  methods: {
    regWeight(row) {
      console.log();
      let reg = new RegExp('^([1-9]|[1-9]\\d|100)$');
      if (!reg.test(row.weight)) {
        if (row.weight - 0 > 100) {
          row.weight = 100;
        } else {
          row.weight = 1;
        }
      }
    },
    expandRow({ row, rowIndex }) {
      this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.$refs.home.updateData(this.tableData);
    },
    closeCreate() {
      this.form = {};
      this.approveReason = '';
    },
    refreshList() {
      this.searchParam.Type = '';
      this.page.PageIndex = 1;
      this.getList();
    },
    changeModel() {
      this.page.PageIndex = 1;
      this.getList();
    },
    getRouteList() {
      this.$ajax.get(this.$api.home.common.list, { userId: sessionStorage.getItem('LOGIN_NAME') }).then((res) => {
        this.routeList = res.data;
        const menusStr = sessionStorage.getItem('menus') || '[]';
        this.routeList = this.routeList.filter(item => menusStr.includes(`"${item.functionUrl}"`))
      });
    },
    getNoticeList() {
      this.$ajax
        .get(this.$api.notice.list, {
          PageIndex: 1,
          PageSize: 10,
        })
        .then((res) => {
          this.noticeList = res.data.rows;
        });
    },
    getList() {
      let param = Object.assign({}, this.searchParam, {
        SkipCount: (this.page.PageIndex - 1) * this.page.PageSize,
        MaxResultCount: this.page.PageSize,
      });
      this.$ajax.get(this.$api.home.work.list, param).then((res) => {
        this.tableData = res.data.rows.list;
        this.tableData.forEach((val) => {
          val.expandRowFlag = false;
        });
        this.total = res.data.total;
      });
    },
    handlePageChange({ currentPage }) {
      this.page.PageIndex = currentPage;
      this.getList();
    },
    sortChange({ column, order }) {
      console.log(order, column);
      if (column.property === 'completeStatus') {
        this.$set(this.searchParam, 'OrderByWorkClassify', '');
        this.$set(this.searchParam, 'OrderByFinishDate', '');
        if (order === 'desc') {
          this.$set(this.searchParam, 'OrderByCompleteStatus', 1);
        } else {
          this.$set(this.searchParam, 'OrderByCompleteStatus', 0);
        }
      } else if (column.property === 'finishDate') {
        this.$set(this.searchParam, 'OrderByCompleteStatus', '');
        this.$set(this.searchParam, 'OrderByWorkClassify', '');
        if (order === 'desc') {
          this.$set(this.searchParam, 'OrderByFinishDate', 1);
        } else {
          this.$set(this.searchParam, 'OrderByFinishDate', 0);
        }
      }
      if (column.property === 'workClassify') {
        this.$set(this.searchParam, 'OrderByCompleteStatus', '');
        this.$set(this.searchParam, 'OrderByFinishDate', '');
        if (order === 'desc') {
          this.$set(this.searchParam, 'OrderByWorkClassify', 1);
        } else {
          this.$set(this.searchParam, 'OrderByWorkClassify', 0);
        }
      }
      this.getList();
    },
    customSortMethod() {},
    detail(item) {
      this.noticeDetail = item;
      this.showNoticeDetail = true;
    },
    async submit() {
      const params = this.summaryForm;
      //提交年总结
      if (params.type == 'yearwork') {
        await this.$refs.yearSummaryForm.validate((valid) => {
        if (valid) {
          const paramObj =
          params.status == 20 || params.status == 50
            ? { workId: params.workId, id: params.id, status: 35, firstHalfSummary: params.firstHalfSummary }
            : { workId: params.workId, id: params.id, status: 55, fullSummary: params.fullSummary };
            // 保存年总结
            const saveParam = _.omit(paramObj, ["status"]);
            this.$ajax.post(this.$api.year.yearWorkDetail.updateSummary, [saveParam]).then(() => {
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, [paramObj]).then(() => {
                this.getList(1);
                this.$message.success('提交成功');
                this.showYearSummary = false;
              });
            });
          }
      });
      } else if (params.type == 'monthwork') {
           this.$refs.summaryForm.validate((valid) => {
        if (valid) {
        this.$ajax
          .put(this.$api.month.MonthWorkDetail.commitComplete, [
            {
              id: params.id,
              completeStatus: params.completeStatus,
              reason: params.reason,
            },
          ])
          .then(() => {
            this.getList(1);
            this.$message.success('提交成功');
            this.showMWSummary = false;
          });
        }
        });
      } else if (params.type == 'weekwork') {
        this.$refs.summaryForm.validate((valid) => {
        if (valid) {
        this.$ajax
          .put(this.$api.week.WeekWorkDetail.commitComplete, [
            {
              id: params.id,
              completeStatus: params.completeStatus,
              reason: params.reason,
            },
          ])
          .then(() => {
            this.getList(1);
            this.$message.success('提交成功');
            this.showMWSummary = false;
          });
          }
        });
      }
    },
    changeTarget(row) {
      this.ableClassify = false;
      this.showChange = true;
      this.rowClone = _.cloneDeep(row);
      this.form = _.cloneDeep(row);
      if (this.form.type === 'yearwork') {
        //人力 预算等工作不能修改分类
        if (this.form.workClassify != 0 && this.form.workClassify != 10 && this.form.workClassify != 50) {
          this.ableClassify = true;
           this.workClassifyList = this.yearWorkClassify;
        }else {
          this.workClassifyList = this.yearWorkClassify.filter(t => t.itemValue == 0 || t.itemValue == 10 || t.itemValue == 50);
        }
      } else if (this.form.type === 'monthwork') {
        this.completeList = this.monthCompleteList;
        //人力 预算等工作不能修改分类
        if (this.form.workClassify == 30 || this.form.workClassify == 40) {
          this.ableClassify = true;
           this.workClassifyList = this.monthWorkClassify;
        }else {
          this.workClassifyList = this.monthWorkClassify.filter(t => t.itemValue != 30 && t.itemValue != 40);
        }
      } else if (this.form.type === 'weekwork') {
        this.completeList = this.weekCompleteList;
        //人力 预算等工作不能修改分类
        if (this.form.workClassify == 30) {
          this.ableClassify = true;
          this.workClassifyList = this.weekWorkClassify;
        }else {
          this.workClassifyList = this.weekWorkClassify.filter(t => t.itemValue != 30);
        }
      } else {
        this.workClassifyList = [];
        this.completeList = [];
      }
      this.$set(this.form, 'workClassify', this.form.workClassify.toString());
      this.$set(this.form, 'completeStatus', this.form.completeStatus.toString());
    },
    confirm() {
      this.$refs.planForm.validate((valid) => {
        if (valid) {
          const form = Object.assign({}, this.form);
          delete form.status;
          delete form._XID;
          delete form.expandRowFlag;
          delete this.form.completeStatusSort;
          delete this.form.workClassifySort;
          delete this.rowClone.status;
          delete this.rowClone._XID;
          delete this.rowClone.expandRowFlag;
          delete this.rowClone.completeStatusSort;
          delete this.rowClone.workClassifySort;
          delete form.status;
          this.$ajax
            .post(this.$api.home.work.createModify, {
              modifyPre: JSON.stringify(this.rowClone),
              modifyAfter: JSON.stringify(form),
            })
            .then(() => {
              this.$message.success('修订提交成功');
              this.getList();
              this.showChange = false;
            });
        }
      });
    },
    goPage(e) {
      if (e.functionUrl) {
        this.$router.push(e.functionUrl);
      }
    },
    addRoute() {
      this.dialogVisible = true;
    },
    plus(e) {
      console.log(e);
      if (this.routeList.length == 12) {
        this.$message.error('最多添加12个快捷入口菜单');
        return false;
      }
      this.$ajax.post(this.$api.home.common.add, { userId: sessionStorage.getItem('LOGIN_NAME'), ...e }).then(() => {
        this.getRouteList();
      });
    },
    remove(e) {
      this.$ajax.delete(`${this.$api.home.common.delete}/${e.id}`).then(() => {
        this.getRouteList();
      });
    },
    weightSearch(queryString, cb) {
      let programList = [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }];
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    getYearWorkClassify() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'YearPlanWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.yearWorkClassify = (res.data && res.data.rows) || [];
        }
      });
    },
    getMonthWorkClassify() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'MonthWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.monthWorkClassify = (res.data && res.data.rows) || [];
        }
      });
    },
    getWeekWorkClassify() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'WeekWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.weekWorkClassify = (res.data && res.data.rows) || [];
        }
      });
    },
    getWeekWorkItemProcessStatus() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'WeekWorkItemProcessStatus' }).then((res) => {
        if (res.code === 0) {
          this.weekCompleteList = (res.data && res.data.rows) || [];
        }
      });
    },
    getMonthWorkItemProcessStatus() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'MonthWorkItemProcessStatus' }).then((res) => {
        if (res.code === 0) {
          this.monthCompleteList = (res.data && res.data.rows) || [];
        }
      });
    },
    getCategory() {
      this.$ajax.get(this.$api.Identity.Categord.categoryByNo, { userId: sessionStorage.getItem('LOGIN_NAME') }).then((res) => {
        const item = res.data || [];
        this.categoryList = this.filterCategory(item);
      });
    },
    queryCategory(queryString, cb) {
      let categoryList = this.categoryList;
      // 调用 callback 返回建议列表的数据
      cb(categoryList);
    },
    submitYearSummary(row) {
      this.showYearSummary = true;
      this.summaryForm = _.cloneDeep(row);
      this.$set(this.summaryForm, 'completeStatus', this.summaryForm.completeStatus.toString());
    },
    submitMWSummary(row) {
      this.showMWSummary = true;
      this.summaryForm = _.cloneDeep(row);
      if (this.summaryForm.type === 'monthwork') {
        this.completeList = this.monthCompleteList;
      } else if (this.summaryForm.type === 'weekwork') {
        this.completeList = this.weekCompleteList;
      } else {
        this.completeList = [];
      }
      this.$set(this.summaryForm, 'completeStatus', this.summaryForm.completeStatus.toString());
    },
    workClassifyName(row) {
      if (row.type === 'yearwork') {
        const workClassifyObj = this.yearWorkClassify.find((t) => t.itemValue * 1 === row.workClassify);
        return workClassifyObj ? workClassifyObj.itemDesc : '';
      } else if (row.type === 'monthwork') {
        const workClassifyObj = this.monthWorkClassify.find((t) => t.itemValue * 1 === row.workClassify);
        return workClassifyObj ? workClassifyObj.itemDesc : '';
      } else if (row.type === 'weekwork') {
        const workClassifyObj = this.weekWorkClassify.find((t) => t.itemValue * 1 === row.workClassify);
        return workClassifyObj ? workClassifyObj.itemDesc : '';
      } else {
        return '';
      }
    },
    disableEdit(row) {
      if (row.type === 'yearwork' && (row.workClassify === 30 || row.workClassify === 40)) {
        return false;
      } else {
        return true;
      }
    },
    goDetail(row) {
      if (row.msgCategory == '1' || row.msgCategory == '2') {
        this.$ajax.put(this.$api.notice.handle, [row.id]).then(() => {
          this.getNoticeList();
        });
      }
      clearTimeout(this.time); //首先清除计时器
      this.time = setTimeout(() => {
        switch (row.msgObjectType) {
          case 'WeekWork':
            this.$router.push({
              path: '/personal/week/detail',
              query: {
                id: row.msgObjectId,
                status: row.status,
                childIds: row.msgObjectChildId ? row.msgObjectChildId.join(',') : '',
                editStatus: row.msgCategory == '3' ? 'approve' : 'edit',
                msgId: row.id,
              },
            });
            break;
          case 'MonthWork':
            this.$router.push({
              path: '/personal/month/detail',
              query: {
                id: row.msgObjectId,
                status: row.status,
                childIds: row.msgObjectChildId ? row.msgObjectChildId.join(',') : '',
                editStatus: row.msgCategory == '3' ? 'approve' : 'edit',
                msgId: row.id,
              },
            });
            break;
          case 'DayWork':
            this.$router.push({
              path: '/personal/day/detail',
              query: {
                id: row.msgObjectId,
                status: row.status,
                editStatus: row.sendAction == 'DayWorkCommitReply' ? '' : 'approve',
              },
            });
            break;
          case 'YearPlan':
            const yearExtend = JSON.parse(row.extend || '{}');
            const query = {
              id: row.msgObjectId,
              status: row.status,
              editStatus: row.msgCategory == '3' ? 'approve' : 'edit',
              childIds: row.msgObjectChildId ? row.msgObjectChildId.join(',') : '',
              msgId: row.id,
              from: 'message',
            };
            if (yearExtend.Version && yearExtend.Version > 'V0') {
              this.$router.push({
                path: '/personal/year-plan/detail-next',
                query,
              });
            } else {
              this.$router.push({
                path: '/personal/year-plan/detail',
                query,
              });
            }
            break;
          case 'ModifyWork':
            this.dialogContent = {
              title: '修订审批',
              componentName: 'modifyApprove',
              msgObjectId: row.msgObjectId,
              role: row.sendAction === 'WorkModifyCommit' && this.currentTab !== 1 ? 1 : 0,
              extend: row.extend
            };
            this.$refs.modifyApprove.show();
            break;
          case 'PublishMonthWork':
            if (row.msgCategory === '1') {
              this.dialogContent = {
                title: '新增工作发布',
                componentName: 'taskApprove',
                msgObjectId: row.msgObjectChildId,
                role: row.sendAction === 'PublishMonthWorkCommit' && this.currentTab !== 1 ? 1 : 0,
                msgId: row.id,
                sendName:JSON.parse(row.extend).CreatorUserName
              };
            }
            if (row.msgCategory === '2') {
              this.dialogContent = {
                title: '新增工作发布',
                componentName: 'taskApprove',
                msgObjectId: row.msgObjectId,
                msgObjectChildId: row.msgObjectChildId? row.msgObjectChildId.join(","): '',
                role: row.sendAction==="PublishMonthWorkCommit"&&this.currentTab!==1? 1: 0,
                noticeType:'addWork',
                msgObjectType:row.msgObjectType,
                sendName:JSON.parse(row.extend).CreatorUserName
             }
            }
            if (row.msgCategory === '3') {
              this.dialogContent = {
                title: '新增工作发布',
                componentName: 'taskApprove',
                msgObjectId: row.msgObjectChildId,
                role: row.sendAction === 'PublishMonthWorkCommit' && this.currentTab !== 1 ? 1 : 0,
                msgId: row.id,
                sendName:JSON.parse(row.extend).CreatorUserName
              }
            }
            this.$refs.taskApprove.show();
            break;
          case 'PublishWeekWork':
            if (row.msgCategory === '1') {
              this.dialogContent = {
                title: '新增工作发布',
                componentName: 'weekApprove',
                msgObjectId: row.msgObjectChildId,
                role: row.sendAction === 'PublishedWeekWork_Leader' && this.currentTab !== 1 ? 1 : 0,
                msgId: row.id,
                sendName:JSON.parse(row.extend).CreatorUserName
              };
            }
            if (row.msgCategory === '2') {
              this.dialogContent = {
                title: '新增工作发布',
                componentName: 'weekApprove',
                msgObjectId: row.msgObjectId,
                msgObjectChildId: row.msgObjectChildId? row.msgObjectChildId.join(","): '',
                role: row.sendAction==="PublishedWeekWork_Leader"&&this.currentTab!==1? 1: 0,
                noticeType:'addWork',
                msgObjectType:row.msgObjectType,
                sendName:JSON.parse(row.extend).CreatorUserName
             }
            }
            if (row.msgCategory === '3') {
              this.dialogContent = {
                title: '新增工作发布',
                componentName: 'weekApprove',
                msgObjectId: row.msgObjectChildId,
                role: row.sendAction === 'PublishedWeekWork_Leader' && this.currentTab !== 1 ? 1 : 0,
                msgId: row.id,
                sendName:JSON.parse(row.extend).CreatorUserName
              }
            }
            this.$refs.weekApprove.show();
            break;
          case 'PublishYearWork':
            if (row.msgCategory === '1') {
              this.dialogContent = {
                title: '年计划修订',
                componentName: 'yearApprove',
                msgObjectId: row.msgObjectChildId,
                role: row.sendAction==="PublishMonthWorkCommit"? 1: 0,
                sendName:JSON.parse(row.extend).CreatorUserName
              }
            }
            if(row.msgCategory==="2"){
              this.dialogContent = {
                title: '年计划修订',
                componentName: 'yearApprove',
                msgObjectId: row.msgObjectId,
                msgObjectChildId: row.msgObjectChildId? row.msgObjectChildId.join(","): '',
                role: row.sendAction==="PublishYearWorkCommit"&&this.currentTab!==1? 1: 0,
                noticeType:'addWork',
                sendName:JSON.parse(row.extend).CreatorUserName
              }
            }
            if (row.msgCategory === '3') {
              this.dialogContent = {
                title: '年计划修订',
                componentName: 'yearApprove',
                msgObjectId: row.msgObjectChildId,
                role: row.sendAction === 'PublishYearWorkCommit' && this.currentTab !== 1 ? 1 : 0,
                msgId: row.id,
                sendName:JSON.parse(row.extend).CreatorUserName
              }
            }
            this.$refs.yearApprove.show();
            break;
          case 'TransferWork':
            this.transferContent = {
              title: '转移工作审批',
              componentName: 'transfer',
              msg: row,
              role: row.msgCategory == '3' ? 1 : 0,
            };
            this.$refs.transfer.show();
            break;
          case 'HandoverWork':
            this.transferContent = {
              title: '交接工作审批',
              componentName: 'transfer',
              msg: row,
              role: row.msgCategory == '3' ? 1 : 0,
            };
            this.$refs.transfer.show();
            break;
          case "ExecuteForm":
              this.showNoticeDetail=true;
              this.noticeDetail=row;
            break;
          case 'OEC':
            let tab;
            if (['OECAmendmentCommit', 'OECAmendmentCommitPassed', 'OECAmendmentCommitRejected'].includes(row.sendAction)) {
              tab = 3;
            }
            if(row.msgCategory == '3') {
              this.$router.push({
                path: '/manage/declare',
                query: {
                  wkNo: row.sendNo,
                  msgId: row.id,
                  role: 1,
                  date: row.extend ? JSON.parse(row.extend).Year + '-' + JSON.parse(row.extend).Month : '',
                  tab,
                },
              });
            }else if(row.msgCategory == '1') {
              this.$router.push({
                path: '/manage/declare',
                query: {
                  date: row.extend ? JSON.parse(row.extend).Year + '-' + JSON.parse(row.extend).Month : '',
                  tab,
                }
              });
            }
            break;
          case 'PeriodResult':
            if (row.msgCategory == '3') {
              this.$router.push({
                path: '/period/periodresult/index',
                query: {
                  wkNo: row.sendNo,
                  msgId: row.id,
                  role: 1,
                  year: row.extend ? JSON.parse(row.extend).Year : '',
                  period: row.extend ? JSON.parse(row.extend).Period : '',
                  editStatus: 'approve'
                },
              });
            } else if (row.msgCategory == '1') {
              this.$router.push({
                path: '/period/periodresult/index',
                query: {
                  msgId: row.id,
                  year: row.extend ? JSON.parse(row.extend).Year : '',
                  period: row.extend ? JSON.parse(row.extend).Period : '',
                },
              });
            }
            break;
          case 'WorkScore':
            this.$router.push({
              path: '/personal/workscore/detail',
              query: {
                msgId: row.id,
                id: row.msgObjectId,
                editStatus: row.msgCategory == '3' ? 'approve' : 'edit'
              },
            });
            break;
          case 'ImportantSort':
            if (row.msgCategory == '3') {
              this.$router.push({
                path: '/period/importance-sort/index',
                query: {
                  wkNo: row.sendNo,
                  msgId: row.id,
                  role: 1,
                  editStatus: 'approve'
                },
              });
            } else {
              this.$router.push({
                path: '/period/importance-sort/index',
                query: {
                  msgId: row.id,
                },
              });
            }
            break;
        }
      }, 300);
    },
    yes() {
      const t = window.devicePixelRatio;
      this.win.document.body.style.zoom = -0.6 * t + 1.55;
      sessionStorage.setItem('zoom', -0.6 * t + 1.55);
      this.showTip = false;
    },
    openPage(row) {
      clearTimeout(this.time);
      switch (row.msgCategory) {
        case '1':
          this.$router.push({
            path: '/notice/index',
          });
          break;
      }
      switch (row.msgCategory) {
        case '2':
          this.$router.push({
            path: '/notice/addWork',
          });
          break;
      }
      switch (row.msgCategory) {
        case '3':
          this.$router.push({
            path: '/notice/approve',
          });
          break;
      }
    },
    getMsgType(){
      this.$ajax.get(this.$api.Identity.BasicData.all,{ItemType: "MsgObjectType"}).then(res=>{
        this.msgTypeList = this.filterMsgType(res.data.rows || []);
      }).catch(()=>{})
    },
  },
};
</script>
<style lang="scss">
.index {
  height: 100%;
  .top {
    padding: 6px 0 24px 20px;
  }
  .route {
    text-align: center;
    width: 60px;
    .el-button {
      width: 60px;
      height: 60px;
      border-radius: 16px;
      i {
        font-size: 36px;
      }
    }
    p {
      font-size: 14px;
      width: 100%;
      word-break: break-all;
      margin-top: 16px;
      line-height: 20px;
    }
  }
  .bot {
    flex-grow: 1;
    overflow: auto;
    .msg {
      flex: 1;
      height: 100%;
      margin-right: 20px;
      .el-scrollbar {
        height: 100%;
        .el-scrollbar__wrap {
          overflow-x: hidden;
        }
        .msg-list {
          li {
            color: $--color-text-primary;
            font-size: 14px;
            i.icon-urgent {
              font-size: 18px;
              color: #ff6562;
              position: relative;
              top: -2px;
            }
            .a-urgent,
            .s-urgent {
              display: inline-block;
              width: 18px;
              margin-right: 8px;
              text-align: center;
              height: 100%;
              vertical-align: top;
              span {
                display: inline-block;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: $--color-black;
                vertical-align: middle;
                margin-bottom: 3px;
              }
              span.style_3_5 {
                background-color: #ffbe4a;
              }
              span.style_more_5 {
                background-color: #22b6a1;
              }
            }
            i.icon-avatar-93{
              color: #909695;
              font-size: 12px;
            }
            i.icon-time-94 {
              color: #c5cfd9;
              font-size: 14px;
            }
          }
          .msg-ellipsis {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            .msg-content-1 {
              display: inline-flex;
              flex-direction: row;
              flex-shrink: 1;
              margin: 0;
              padding: 0;
              line-height: 22px;
              width: 100%;
              .msg-content-text {
                font-size: 15px;
                line-height: 22px;
                margin: 0px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .msg-content-2 {
              color: #909695;
              margin-top: 8px;
              margin-bottom: 16px;
              margin-left: 22px;
              .icon-avatar-93 {
                margin-right: 5px;
              }
              .icon-time-94 {
                margin-left: 14px;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
    .kpi {
      flex: 3;
      .notice-title {
        .handle {
          font-size: 14px;
          color: $--color-text-regular;
          .refresh {
            i{
              margin-right: 5px;
            }
            margin-left: 15px;
            cursor: pointer;
            font-weight: normal;
          }
          .el-radio {
            margin-right: 5px;
          }
          .el-radio__label{
            padding: 0 12px 0 8px;
            display: inline-block;
            vertical-align: bottom;
            height: 16px;
          }
          .el-dropdown {
            font-weight: normal;
            font-size: 14px;
            margin-right: 10px;
          }
        }
      }
      .table-content {
        flex-grow: 1;
        overflow: auto;
      }
    }
  }
  .common {
    h2 {
      margin-bottom: 0;
    }
  }
  .result {
    margin-top: 15px;
    padding: 15px 20px 15px 20px;
    flex-wrap: wrap;
    .route {
      margin-bottom: 12px;
      &:nth-child(7n){
        margin-right: 0;
      }
    }
  }
  .all {
    margin-top: 20px;
    h2 {
      margin-bottom: 0;
    }
  }
  .el-button {
    &.el-button--primary {
      width: 112px;
      box-shadow: 0 0 5px rgba($--color-primary, 0.4);
    }
    &.el-button--cancel {
      background: $--color-route-yellow;
      border-color: $--color-route-yellow;
      color: $--color-white;
      box-shadow: 0 0 5px rgba($--color-route-yellow, 0.4);
      margin-left: 10px;
    }
  }
  .el-dialog {
   
    &.route-dialog {
      .content {
        height: 400px;
        overflow: auto;
      }
      .el-dialog__footer {
        padding-top: 6px;
        padding-bottom: 40px;
      }
    }
    &.changeDialog {
      .content {
        height: 500px;
        overflow: auto;
        .el-date-editor,
        .el-autocomplete {
          width: 100%;
        }
      }
      .el-select {
        width: 100%;
      }
    }
  }
  .el-dialog__body {
    .content {
      li {
        padding: 10px 0;
        span.label {
          font-size: 14px;
          color: $--color-text-regular;
          flex: 0 0 64px;
          margin-right: 20px;
          text-align: right;
        }
        .res {
          flex: 1;
          font-weight: bold;
          color: $--color-text-primary;
          font-size: 14px;
          &.name {
            color: $--color-primary;
          }
          &.notice-res {
            font-weight: normal;
            line-height: 1.4;
          }
        }
      }
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
  }
  .el-form-item__label {
    height: 40px;
    line-height: 1.2;
    display: flex;
    text-align: right;
    align-items: center;
    justify-content: flex-end;
  }
  .msg-ellipsis {
    cursor: pointer;
  }
}
</style>
